var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArroba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.057 17.7772C25.4721 16.164 13.4338 12.4365 13.1475 19.8816C13.0481 22.4664 12.9461 24.9941 16.1779 25.3532C20.3858 25.8207 26.8667 30.579 30.8668 25.6899C39.029 15.7139 24.1245 -0.283989 12.2215 4.47717C4.42541 7.59563 -3.25511 21.2988 5.40317 27.626C12.0696 32.4976 19.5383 34.4443 27.8785 34.4443C38.7705 34.4443 37.3906 22.6281 37.3906 14.7889C37.3906 9.5559 34.2342 6.22419 31.3298 1.86768",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArroba);
export default __webpack_public_path__ + "static/media/arroba.1eeee180b1f577cd01bcba29cd469c8d.svg";
export { ForwardRef as ReactComponent };